import hash from 'stable-hash';
import xxhash from 'xxhash-wasm';
import { murmur3 } from 'murmurhash-js';

// 全局单例
window.top.__mpHasher = null;

// 增强型初始化
export async function initXxhashWithFallback() {
  try {
    if (!window.top.__mpHasher) {
      const hasher = await xxhash();
      // window.top.__mpHasher = hasher.h32;
      window.top.__mpHasher = hasher.h64;
    }
  } catch (err) {
    console.warn('Hasher fallback');
    // 降级到纯 JS 哈希
    window.top.__mpHasher = murmur3;
  }
}

// 安全调用封装
export function safeHash(input: string | Uint8Array): string {
  if (!window.top.__mpHasher) {
    initXxhashWithFallback().catch((e) => {
      console.log(e);
    });
    console.log('Hasher fallback');
    window.top.__mpHasher = murmur3;
    return murmur3(input);
  }
  return window.top.__mpHasher(input);
}

// 请求参数对应的缓存key
export const getCacheKey = (params) => {
  // key有点长
  return safeHash(hash(params));
};

// 初始化（应用入口）
// initXxhash().catch(console.error);
initXxhashWithFallback();
